// extracted by mini-css-extract-plugin
module.exports = {"line":"RegisterPage_line__120cU","form":"RegisterPage_form__10UW3","RegisterPage":"RegisterPage_RegisterPage__kv4qe"};